module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "d7e90"
    }
  }, [_c('h1', {
    staticClass: "chapno"
  }), _c('h2', {
    staticClass: "chapttl",
    attrs: {
      "id": "d7e91"
    }
  }, [_vm._v("Praise for The Complete Guide to Reverse Mortgages")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e93"
    }
  }, [_vm._v("“If you have time to read only one book about reverse mortgages this is it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e95"
    }
  }, [_vm._v("— "), _c('b', [_vm._v("Peggy Gardner, J.D., C.P.A.,")]), _vm._v(" President,")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e100"
    }
  }, [_vm._v("Estate Planning Council of Colorado Springs")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e102"
    }
  }, [_vm._v("“I predict "), _c('i', [_vm._v("The Complete Guide to Reverse Mortgages")]), _vm._v(" will become the most widely used third-party resource tool for potential borrowers, their families, and the professionals who advise them.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e107"
    }
  }, [_vm._v("— "), _c('b', [_vm._v("Norman F. Peterson,")]), _vm._v(" President,")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e112"
    }
  }, [_vm._v("Kirkpatrick Bank")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e114"
    }
  }, [_vm._v("“Every financial and retirement planning professional should read this book. This book unravels a complex and very important topic in a clear and entertaining style.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e116"
    }
  }, [_vm._v("— "), _c('b', [_vm._v("Raj Joshi,")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e120"
    }
  }, [_vm._v("Financial Analyst and Advisor")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e122"
    }
  }, [_vm._v("“With the leading edge of nearly 80 million baby boomers set to hit the entry-age for reverse mortgages in the next year and reverse mortgage lending up 73 percent in 2006, this book is a must.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e125"
    }
  }, [_vm._v("— "), _c('b', [_vm._v("Robert Crandall, C.P.A.,")]), _vm._v(" Member,")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e130"
    }
  }, [_vm._v("American Institute of Certified Public Accountants")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e132"
    }
  }, [_vm._v("“The one-of-a-kind graphics and clear writing style in the Kraemers' book unravel the mystery of how reverse mortgages transform home equity into useable retirement cash.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e134"
    }
  }, [_vm._v("— "), _c('b', [_vm._v("John N. Yates, CLU, CFP, ChFC and MSFS,")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e138"
    }
  }, [_vm._v("Financial Planner")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e140"
    }
  }, [_vm._v("“"), _c('i', [_vm._v("The Complete Guide to Reverse Mortgages")]), _vm._v(" eliminates common misconceptions and distills a complex subject into an accessible resource for borrowers, their families, and the professionals who advise them.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e145"
    }
  }, [_vm._v("— "), _c('b', [_vm._v("Robert Wrubel,")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e149"
    }
  }, [_vm._v("Senior Investment Consultant")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e151"
    }
  }, [_vm._v("“The Kraemers have taken a complex subject and made it very understandable.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e153"
    }
  }, [_vm._v("— "), _c('b', [_vm._v("Diana Capoot,")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e157"
    }
  }, [_vm._v("Financial Consultant")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f73b3cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Krae_9781440501029_epub_part3.vue
// module id = 72
// module chunks = 0